import { useEffect, useRef, useState } from "react";
import { useFormikWrapper } from "../../../components/formik_wrapper";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import QRcode from "qrcode";
import * as actions from "../../../actions";
import { Tooltip } from "flowbite-react";
import { SearchDropdown, TextArea } from "../../../components/inputs";
import { Popup } from "../../../components/pop-up";
import { ZuperProV3URL, ZuperProV2URL } from "../../../util/master-data";
import { Modal } from "flowbite-react";
import {
  userAgents,
  extendedValidities,
  tokenValidities,
  loginAsUserReasons,
} from "../../../util/master-data";
import { IconButton } from "../../../components/buttons";

export function LoginAsUser({ data, onConfirm, companyDetails }) {
  // const [extendedValidity, setExtendedValdity] = useState(false);
  const dispatch = useDispatch();
  const dropdownref = useRef();
  const _extendedValidities = extendedValidities
  const [formModal, setFormModal] = useState();
  const [qrModel, setQRModal] = useState();
  const [qrCode, setQRcode] = useState();

  const loginAsUserResponse = useSelector(
    (state) => state.company.login_as_user
  );

  useEffect(() => {
    if (qrCode) setQRModal("pop-up");
  }, [qrCode]);

  useEffect(() => {
    const selectedRegion = localStorage.getItem("region_code");
    setFormModal()
    resetForm();
    if (loginAsUserResponse && data.user_uid === loginAsUserResponse.user.user_uid) {
      if (loginAsUserResponse.client === "Mobile") {
        QRcode.toDataURL(loginAsUserResponse.auth_token).then((qr) => {
          setQRcode(qr);
        });
      } else {
        const source = `&source=internal_admin`;
        const region = `&region=${selectedRegion}`;
        const loginName = companyDetails?.company_login_name
          ? `&company_login_name=${companyDetails?.company_login_name}`
          : "";
        const url = `${loginAsUserResponse.client === "Web V3"
          ? ZuperProV3URL
          : ZuperProV2URL
          }/login?access_token=${loginAsUserResponse.auth_token
          }${region}${loginName}${source}`;
        console.log(url);
        window.open(url, "_blank");
        dispatch(actions.RESET_STATE("company.login_as_user"));
        setQRModal();
        setQRcode();
      }
    }
  }, [loginAsUserResponse]);


  const userLoginForm = useFormikWrapper({
    initialValues: {
      token_validity: 15,
      remarks: "",
      client: data.role?.role_key === "FIELD_EXECUTIVE" ? "Mobile" : "Web V3",
      reason: "",
    },
    validationSchema: Yup.object({
      token_validity: Yup.number().required("Please select duration"),
      client: Yup.string().required("Please select the user agent"),
      reason: Yup.string().required("Please select a reason"),
      remarks: Yup.string()
        .when("reason", {
          is: (reason) => {
            let selected = loginAsUserReasons.find(
              (_val) => _val.reason === reason
            );
            return selected?.free_text_required;
          },
          then: (schema) => schema.required("Please enter the comments"),
        })
        .min(3, "Atleast 3 characters required"),
    }),
    onSubmit: () => {
      dispatch(
        actions.LOGINASUSER_REQ({
          company_uid: companyDetails['company_uid'],
          user_uid: data.user_uid,
          formData: userLoginForm.values,
          user_name: (data.first_name || "") + " " + (data.last_name || ""),
        })
      );
    },
  });

  const resetForm = () => {
    userLoginForm.setValues({
      token_validity: 15,
      remarks: "",
      client: data.role?.role_key === "FIELD_EXECUTIVE" ? "Mobile" : "Web V3",
    });
    userLoginForm.setTouched({
      token_validity: false,
      remarks: false,
      client: false,
    });
  };

  const [commentsRequired, setRequired] = useState();

  useEffect(() => {
    let reason = userLoginForm.values.reason;
    let selected = loginAsUserReasons.find((_val) => _val.reason === reason);
    setRequired(selected?.free_text_required);
  }, [userLoginForm.values.reason]);

  const closeQRModal = () => {
    dispatch(actions.RESET_STATE("company.login_as_user"));
    setQRModal();
    setQRcode();
  };
  return (
    <>
      <Tooltip content="Login as user" placement="bottom">
        <IconButton
          onClick={() => {
            setFormModal("pop-up");
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-4 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
            />
          </svg>
        </IconButton>
      </Tooltip>
      <Popup
        size="2xl"
        header={`Login as ${data.first_name + " " + data.last_name}`}
        content={
          <div className=" relative  py-3 flex flex-col text-left justify-items-start">
            <fieldset className="grid grid-cols-4 gap-x-4 w-full mb-2 ">
              <legend className="text-sm font-medium text-gray-900 dark:text-gray-300 mb-3">
                Choose Session Duration
              </legend>
              {tokenValidities.map((_mins) => (
                <div>
                  <input
                    type="radio"
                    name="token_validity"
                    value={_mins}
                    id={_mins}
                    onChange={() => {
                      userLoginForm.setFieldValue("token_validity", _mins);
                    }}
                    checked={_mins === userLoginForm.values.token_validity}
                    className="peer hidden [&:checked_+_label_svg]:block"
                  />

                  <label
                    htmlFor={_mins}
                    className="block shadow-md cursor-pointer rounded-lg border border-gray-100 bg-white p-4 text-md font-medium  hover:border-gray-200 peer-checked:border-gray-700 peer-checked:ring-1 peer-checked:ring-gray-500"
                  >
                    <div className="flex items-center justify-between">
                      <p className="text-gray-700">{_mins} mins</p>

                      <svg
                        className="hidden h-5 w-5 text-gray-700"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </label>
                </div>
              ))}
              <div>
                <input
                  type="radio"
                  name="extended-validity"
                  value="extended-validity"
                  id="extended-validity"
                  onClick={() => {
                    dropdownref.current.click();
                  }}
                  checked={extendedValidities
                    .map((_v) => _v.key)
                    .includes(userLoginForm.values.token_validity)}
                  className="peer hidden [&:checked_+_label_svg]:block"
                />
                <label
                  htmlFor="extended-validity"
                  className="block cursor-pointer shadow-md rounded-lg border border-gray-100 bg-white p-4 text-md font-medium  hover:border-gray-200 peer-checked:border-gray-700 peer-checked:ring-1 peer-checked:ring-gray-500"
                >
                  <div className="flex items-center justify-between">
                    <p className="text-gray-700">
                      {extendedValidities
                        .map((_v) => _v.key)
                        .includes(userLoginForm.values.token_validity)
                        ? extendedValidities?.filter(
                          (_v) =>
                            _v.key === userLoginForm.values.token_validity
                        )[0]?.value
                        : "More"}
                      {/* Extended */}
                    </p>
                    <svg
                      className="hidden h-5 w-5 text-gray-700"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                </label>
                <SearchDropdown
                  formik={userLoginForm}
                  showNull={false}
                  ref={dropdownref}
                  name="token_validity"
                  className="col-span-4 relative [&>ul]:-mt-2 [&>#trigger]:hidden [&>div]:mt-0 [&>*>*>*>input]:p-4 [&>*>*>*>input]:font-medium [&>p]:hidden"
                  options={extendedValidities}
                />
              </div>

              {userLoginForm.touched.token_validity &&
                userLoginForm.errors.token_validity && (
                  <p className=" col-span-4 first-letter:uppercase mt-2 text-sm text-red-500">
                    {userLoginForm.errors.token_validity}
                  </p>
                )}
            </fieldset>
            <SearchDropdown
              className="mb-2"
              name="client"
              label="Choose User Agent"
              formik={userLoginForm}
              showNull={false}
              options={userAgents}
            />
            <SearchDropdown
              className="mb-2"
              name="reason"
              label="Choose Login Reason"
              formik={userLoginForm}
              showNull={false}
              optionId="reason"
              optionName="reason"
              options={loginAsUserReasons}
            />
            <TextArea
              formik={userLoginForm}
              name="remarks"
              type="textarea"
              required={commentsRequired}
              label="Comments"
            />
          </div>
        }
        confirmText="Login"
        modalState={[formModal, setFormModal]}
        alignActions="end"
        onConfirm={() => {
          userLoginForm.submitForm();
        }}
        onClose={resetForm}
      />

      <Modal
        show={qrModel === "pop-up"}
        size="lg"
        popup
        onClose={() => closeQRModal()}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="flex flex-col items-center justify-center">
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-500">
              Scan from Zuper Mobile to login.
            </h3>
            <div>{qrCode && <img src={qrCode} alt="" />}</div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
}
